import { FC } from 'react';
import { DotSpinner } from '@crono-one/design-system';
import { toast } from '@crono-one/design-system/side-effects';

import PATH from 'crono-fe-common/constants/path';
import { useConnectZoomInfo } from 'hooks/services/externalEnrichmentProviders/zoominfo/useConnectZoomInfo';
import {
  ZOOMINFO_REDIRECT_URI,
  ZOOMINFO_STATE_KEY,
} from 'pages/settings/EnrichmentProviders/enrichment-providers.service';
import useOauthCallbackCode from 'pages/connect/views/useOauthCallbackCode';

// Wired to the settled paths only: a callback that fails the state check must
// leave the nonce alone, or a forged redirect would invalidate the legitimate
// flow still pending in this tab.
const clearStoredState = () => sessionStorage.removeItem(ZOOMINFO_STATE_KEY);

const ZoomInfoLoginHandler: FC = () => {
  const { mutate: connectZoomInfo } = useConnectZoomInfo();

  useOauthCallbackCode({
    provider: 'ZoomInfo',
    exchangeCode: connectZoomInfo,
    buildVariables: (code) => ({ code, redirectUri: ZOOMINFO_REDIRECT_URI }),
    missingCodePath: PATH.SETTINGS.ENRICHMENT_PROVIDERS,
    successPath: PATH.SETTINGS.ENRICHMENT_PROVIDERS,
    errorPath: PATH.SETTINGS.ENRICHMENT_PROVIDERS,
    requiresUser: false,
    guard: ({ state }) => {
      const storedState = sessionStorage.getItem(ZOOMINFO_STATE_KEY);
      if (typeof state === 'string' && state !== '' && state === storedState) {
        return true;
      }

      toast.error('ZoomInfo returned an unexpected state');
      return false;
    },
    onSuccess: clearStoredState,
    onError: clearStoredState,
  });

  return (
    <div className="flex h-full w-full items-center justify-center">
      <DotSpinner />
    </div>
  );
};

export default ZoomInfoLoginHandler;
